export const getRequestHeaders = token =>
    (token ? {'Authorization': 'Bearer ' + token} : {});
